export const INIT_CART_ID = "INIT_CART_ID";
export const INIT_CART_COUNTER = "INIT_CART_COUNTER";
export const SET_CART_COUNTER = "SET_CART_COUNTER";
export const SET_CART_ITEMS = "SET_CART_ITEMS";
export const ADD_CART_ITEMS = "ADD_CART_ITEMS";
export const REMOVE_CART_ITEMS = "REMOVE_CART_ITEMS";
